import React, { useState } from "react";
import { Form, Row, Col /* Button,  Spinner */ } from "react-bootstrap";
// import { ReactComponent as OutlinePlus16 } from "assets/svg/outline-plus-16.svg";
import { ReactComponent as OutlineCross } from "assets/svg/outline-cross.svg";
import {
  ORCHID_PRO_TYPE_OPTIONS,
  PHYSICIAN_PRIMARY_SPECIALTY,
  PSYCHIATRY_SUBSPECIALTY_OPTIONS,
  PAIN_MED_SUBSPECIALTY_OPTIONS,
  PSYCHOLOGIST_PRIMARY_SPECIALTY,
  PSYCHOLOGIST_SUBSPECIALTY,
  NEUROLOGY_SUBSPECIALTY_OPTIONS,
} from "../utility/constants";
import {
  checkIsPhysician,
  checkIsPsychologist,
} from "../utility/checkOrchidProType";
import { formatOrchidProTypeOrder } from "../utility/formatOrchidProTypeOrder";
import CustomSelect from "components/custom-select/CustomSelect";
import IconButton from "components/icon-button";
import ConfirmModal from "components/confirm-modal";
import deleteOrchidProTypeById from "services/deleteOrchidProTypeById";
// import createOrchidProType from "services/createOrchidProType";
import postOrchidPro from "services/postOrchidPro";
import getClasses from "utils/getClasses";
import styles from "./styles.module.scss";
import messages from "messages";
import { useUser } from "contexts/UserContext";
import { track } from "utils/amplitude";

const getPhysicianSubspecialty = (specialty) => {
  switch (specialty) {
    case "psychiatry": {
      return PSYCHIATRY_SUBSPECIALTY_OPTIONS;
    }
    case "neurology": {
      return NEUROLOGY_SUBSPECIALTY_OPTIONS;
    }
    case "physical medicine and rehabilitation": {
      return PAIN_MED_SUBSPECIALTY_OPTIONS;
    }
    default:
      return [];
  }
};

const ProTypeUpdate = ({
  data,
  registration,
  fieldChangedCallback,
  reset,
  amplitudePageName,
}) => {
  const { updateUserInfo } = useUser();
  const orchidProTypesInit = data.orchid_pro_types?.slice(0);

  const [error, setError] = useState<any>();
  const [proTypeIdToDelete, setProTypeIdToDelete] = useState(undefined);
  const [indexToDelete, setIndexToDelete] = useState(undefined);

  // const [busy, setBusy] = useState(false);

  const onInputChange = (event) => {
    reset();
    const inputField = event.currentTarget;
    fieldChangedCallback(inputField.name, inputField.value);
  };

  const onOrchidProTypeSelectChange = (key, subKey, index) => (e) => {
    reset();
    if (key === "type") {
      orchidProTypesInit[index] = {
        ...orchidProTypesInit[index],
        orchid_pro_type: {
          type: e.value,
          specialty: {
            specialty: "",
            sub_specialty: null,
          },
        },
      };
    } else if (key === "specialty") {
      const { orchid_pro_type } = orchidProTypesInit[index];
      if (key in orchid_pro_type) {
        if (subKey === "specialty") {
          orchidProTypesInit[index] = {
            ...orchidProTypesInit[index],
            orchid_pro_type: {
              ...orchid_pro_type,
              specialty: { specialty: e.value, sub_specialty: null },
            },
          };
        } else if (subKey === "sub_specialty") {
          const { specialty } = orchid_pro_type;
          orchidProTypesInit[index] = {
            ...orchidProTypesInit[index],
            orchid_pro_type: {
              ...orchid_pro_type,
              specialty: { ...specialty, sub_specialty: e.value },
            },
          };
        }
      }
    }
    fieldChangedCallback("orchid_pro_types", orchidProTypesInit);
  };

  const removeOrchidProType = async () => {
    const {
      orchid_pro_types,
      graduate,
      undergraduate,
      fellowships_json,
      residency_json,
      licenses,
      board_certifications,
      qualifications,
    } = data;

    if (proTypeIdToDelete) {
      // remove objects of this orchid_pro_type_id in relevant fields: graduate, undergraduate, fellowship, residency, licenses, board certifications, qualifications
      const updatedData = {
        graduate: graduate.filter(
          (el) => el.orchid_pro_type_id !== proTypeIdToDelete,
        ),
        undergraduate: undergraduate.filter(
          (el) => el.orchid_pro_type_id !== proTypeIdToDelete,
        ),
        fellowships_json: fellowships_json.filter(
          (el) => el.orchid_pro_type_id !== proTypeIdToDelete,
        ),
        residency_json: residency_json.filter(
          (el) => el.orchid_pro_type_id !== proTypeIdToDelete,
        ),
        licenses: licenses.filter(
          (el) => el.orchid_pro_type_id !== proTypeIdToDelete,
        ),
        board_certifications: board_certifications.filter(
          (el) => el.orchid_pro_type_id !== proTypeIdToDelete,
        ),
        qualifications: qualifications.filter(
          (el) => el.orchid_pro_type_id !== proTypeIdToDelete,
        ),
      };

      // delete immediately at BE, without hitting save button
      try {
        await deleteOrchidProTypeById(proTypeIdToDelete);
        await postOrchidPro(updatedData);
        setIndexToDelete(undefined);
      } catch (error) {
        setError(error);
      } finally {
        await updateUserInfo();
      }
    } else {
      orchid_pro_types.splice(indexToDelete, 1);
      fieldChangedCallback("orchid_pro_types", orchid_pro_types);
      setIndexToDelete(undefined);
    }
  };

  // const addOrchidProType = async () => {
  //   const nextProType = {
  //     orchid_pro_type: {
  //       type: "therapist",
  //       specialty: {
  //         specialty: null,
  //         sub_specialty: null,
  //       },
  //     },
  //   };
  //   setBusy(true);
  //   try {
  //     const response = await createOrchidProType(nextProType.orchid_pro_type);
  //     fieldChangedCallback(
  //       "orchid_pro_types",
  //       orchidProTypesInit.concat(response),
  //     );
  //   } catch (error) {
  //     setError(error);
  //     return;
  //   } finally {
  //     await updateUserInfo();
  //     setBusy(false);
  //   }
  // };

  return (
    <div className={!registration ? styles["intake-form--edit-profile"] : ""}>
      <Row>
        <Col md={6} xs={12} lg={6} className={styles["edit-profile__col"]}>
          <div className={styles["edit-profile__card"]}>
            <div className={styles["edit-profile__col-card"]}>
              <div
                className={getClasses(
                  styles["intake-form__title"],
                  styles["intake-form__title--edit-profile"],
                )}
              >
                Individual NPI Number
              </div>
              <Form.Group>
                <Form.Label className={styles["intake-form__form-label"]}>
                  Individual NPI{" "}
                </Form.Label>
                <Form.Control
                  maxLength={10}
                  minLength={10}
                  type="text"
                  name="national_provider_identifier"
                  // required={isPhysician}
                  value={data.national_provider_identifier || ""}
                  onChange={onInputChange}
                  placeholder={"Enter Individual NPI Number"}
                  onFocus={() =>
                    track(
                      amplitudePageName,
                      "individual-npi-number-field",
                      "focus",
                    )
                  }
                />
              </Form.Group>
            </div>
          </div>
        </Col>

        <Col className={styles["edit-profile__col"]} md={6} xs={12} lg={6}>
          <div className={styles["edit-profile__card"]}>
            <div className={styles["edit-profile__col-card"]}>
              <div
                className={getClasses(
                  styles["intake-form__title"],
                  !registration && styles["intake-form__title--edit-profile"],
                )}
              >
                Organization / Affiliation
              </div>
              <Form.Group>
                <Form.Label className={styles["intake-form__form-label"]}>
                  Organization / Affiliation
                </Form.Label>
                <Form.Control
                  type="text"
                  name="organization"
                  value={data.organization || ""}
                  onChange={onInputChange}
                  placeholder={"Enter Organization/ Affiliation"}
                  onFocus={() =>
                    track(amplitudePageName, "org-affiliation-field", "focus")
                  }
                />
              </Form.Group>
            </div>
          </div>
        </Col>
      </Row>

      <div className={styles["edit-profile__card"]}>
        <div
          className={getClasses(
            styles["intake-form__title"],
            !registration && styles["intake-form__title--edit-profile"],
          )}
        >
          {!registration
            ? "Professional Type"
            : "1. What type of professional are you?"}
        </div>
        <Row className={styles["edit-profile__row"]}>
          {orchidProTypesInit?.map((item, index) => {
            const isPhysician = checkIsPhysician(item);
            const isPsychologist = checkIsPsychologist(item);
            return (
              <Col
                className={styles["edit-profile__col"]}
                key={`${index}-${item.orchid_pro_type_id}`}
                md={6}
                lg={6}
                xs={12}
              >
                <div
                  className={getClasses(
                    "d-flex justify-content-between",
                    orchidProTypesInit.length > 1 && index >= 0 && "mb-3",
                  )}
                >
                  {orchidProTypesInit.length > 1 && (
                    <div className={styles["rg-14"]}>
                      {formatOrchidProTypeOrder(index)}
                    </div>
                  )}
                  {!!index && (
                    <IconButton
                      variant="link"
                      onClick={() => {
                        setError(undefined);
                        setProTypeIdToDelete(item.orchid_pro_type_id);
                        setIndexToDelete(index);
                      }}
                    >
                      <OutlineCross className="gray02" />
                    </IconButton>
                  )}
                </div>
                <Form.Group>
                  <Form.Label className={styles["intake-form__form-label"]}>
                    Professional Type{" "}
                    {index < 1 && <span className="required">*</span>}
                  </Form.Label>
                  <CustomSelect
                    required
                    isMulti={false}
                    onChange={onOrchidProTypeSelectChange("type", null, index)}
                    options={ORCHID_PRO_TYPE_OPTIONS}
                    placeholder={"Select Professional Type"}
                    value={
                      ORCHID_PRO_TYPE_OPTIONS.find(
                        (option) => option.value === item.orchid_pro_type?.type,
                      ) || ""
                    }
                    onFocus={() =>
                      track(
                        amplitudePageName,
                        "professional-type-dropdown",
                        "focus",
                      )
                    }
                  />
                </Form.Group>
                {(isPhysician || isPsychologist) &&
                  (() => {
                    const SPECIALTY_OPTIONS = isPhysician
                      ? PHYSICIAN_PRIMARY_SPECIALTY
                      : isPsychologist
                      ? PSYCHOLOGIST_PRIMARY_SPECIALTY
                      : [];

                    const SUBSPECIALITY_OPTIONS = isPsychologist
                      ? PSYCHOLOGIST_SUBSPECIALTY
                      : getPhysicianSubspecialty(
                          item.orchid_pro_type?.specialty?.specialty,
                        );

                    return (
                      <>
                        <Form.Group>
                          <Form.Label
                            className={styles["intake-form__form-label"]}
                          >
                            Specialty{" "}
                            {index < 1 && <span className="required">*</span>}
                          </Form.Label>
                          <CustomSelect
                            placeholder={"Select Specialty"}
                            required={isPhysician || isPsychologist}
                            isMulti={false}
                            onChange={onOrchidProTypeSelectChange(
                              "specialty",
                              "specialty",
                              index,
                            )}
                            value={
                              SPECIALTY_OPTIONS.find(
                                (option) =>
                                  option.value ===
                                  item.orchid_pro_type?.specialty?.specialty,
                              ) || ""
                            }
                            options={SPECIALTY_OPTIONS}
                            key={`specialty_${item.orchid_pro_type?.type}`}
                            onClick={() =>
                              track(
                                amplitudePageName,
                                "specialty-dropdown",
                                "click",
                              )
                            }
                          />
                        </Form.Group>

                        {item.orchid_pro_type?.specialty?.specialty &&
                          SUBSPECIALITY_OPTIONS.length > 0 && (
                            <Form.Group>
                              <Form.Label
                                className={styles["intake-form__form-label"]}
                              >
                                Sub-Specialty
                              </Form.Label>
                              <CustomSelect
                                isMulti={false}
                                onChange={onOrchidProTypeSelectChange(
                                  "specialty",
                                  "sub_specialty",
                                  index,
                                )}
                                options={SUBSPECIALITY_OPTIONS}
                                placeholder={"Select Sub-Specialty"}
                                value={
                                  SUBSPECIALITY_OPTIONS.find(
                                    (option) =>
                                      option.value ===
                                      item.orchid_pro_type?.specialty
                                        ?.sub_specialty,
                                  ) || ""
                                }
                                key={`subspecialty_${item.orchid_pro_type?.type}_${item.orchid_pro_type?.specialty?.specialty}`}
                                onClick={() =>
                                  track(
                                    amplitudePageName,
                                    "sub-specialty-dropdown",
                                    "click",
                                  )
                                }
                              />
                            </Form.Group>
                          )}
                      </>
                    );
                  })()}
              </Col>
            );
          })}
        </Row>

        {/* {orchidProTypesInit?.length < 3 && (
          <Button
            variant="link"
            className="d-flex align-items-center mb-3 p-0"
            onClick={addOrchidProType}
            disabled={busy}
          >
            <OutlinePlus16 className="mr-1" /> Add Professional Type{" "}
            {busy && (
              <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
                className="ml-3"
              />
            )}
          </Button>
        )} */}
      </div>

      {/* confirm delete orchid pro type */}
      <ConfirmModal
        labelTitle={messages.areYouSure}
        children={messages.doYouWantToDeleteThisSection}
        labelConfirm={messages.delete}
        hideCancel={true}
        show={indexToDelete !== undefined}
        onCancel={() => {
          setProTypeIdToDelete(undefined);
          setIndexToDelete(undefined);
        }}
        error={error}
        onConfirm={() => removeOrchidProType()}
      />
    </div>
  );
};

export default ProTypeUpdate;
